/*
 * First digit will match Project Phase
 * Second digit will change after new release is given to Live.
 * Third digit will change after new release is given for UAT.
 */
export const VERSION: string = '2.0.1';	//Phase.Live.UAT
export const BASE_URL: string = '/lp/';
